import { createContext } from "react";

const CatRegimenFiscalContext = createContext();

export default CatRegimenFiscalContext;
